module.exports = __webpack_public_path__ + "img/residential-icon.c917e24d.svg";